import getParam from './getParam';

const getGame = (lang = 'en') => {
  const href = location.href;

  const nameStore = {
    en: {
      'aion': 'aion',
      'lineage': 'lineage',
      'lineage2': 'lineage2',
      'bns': 'bns',
      'lovebeat': 'lovebeat',
      'event': 'plaync',
      'lineagem': 'lineagem',
      'lineage2m': 'lineage2m',
      'h2': 'h2'
    },
    ko: {
      'aion': '아이온',
      'lineage': '리니지',
      'lineage2': '리니지2',
      'bns': '블소',
      'lovebeat': '러브비트',
      'event': '플레이엔씨',
      'lineagem': '리니지M',
      'lineage2m': '리니지2M',
      'h2': '프로야구H2'
    }
  };

  if (getParam('game')) {
    return nameStore[lang][getParam('game')];
  }
  else {
    if (href.match(/lineagem\.plaync\./)) {
      return nameStore[lang]['lineagem'];
    }
    if (href.match(/lineage2m\.plaync\./)) {
      return nameStore[lang]['lineage2m'];
    }
    if (href.match(/h2\.plaync\./)) {
      return nameStore[lang]['h2'];
    }
    if (href.match(/aion\.plaync\./)) {
      return nameStore[lang]['aion'];
    }
    if (href.match(/bns\.plaync\./)) {
      return nameStore[lang]['bns'];
    }
    if (href.match(/lineage\.plaync\./)) {
      return nameStore[lang]['lineage'];
    }
    if (href.match(/lineage2\.plaync\./)) {
      return nameStore[lang]['lineage2'];
    }
    if (href.match(/lovebeat\./)) {
      return nameStore[lang]['lovebeat'];
    }
    if (href.match(/event\.plaync\./)) {
      return nameStore[lang]['event'];
    }
  }

  return nameStore[lang]['aion'];
};

export default getGame;
